<template lang="pug">
  span
    v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8" z-index="11")
      template(v-slot:activator="{ on, attrs }")
        v-btn.px-2.button-text-normal.button-filter.text-none(v-if="currentActivity" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ $t('activity') }}
          .px-1.neutral400--text |
          .text-xs.primary--text.font-medium {{ selectedActivityDisplay }}
          v-icon.ml-1(size=16) $yzi-chevron-down
        v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(size=13) $yzi-plus-circle
          .text-xs.text-none.font-semibold {{ $t('activity') }}
      // Filter list
      .white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('activity').toLowerCase() }}
        v-radio-group.mx-0.mt-0(v-model="selectedActivity")
          template(v-for="activity in availableActivities")
            v-radio.px-4(:value="activity" :key="`activity-${activity.value}`")
              template(v-slot:label)
                .text-sm.font-normal.primary--text {{ activity.label }}
            y-select.round-lg.px-4.mb-4(v-if="selectedActivity && selectedActivity.value === activity.value" v-model="selectedValue" :items="availableValues" item-text="label" item-value="value" small return-object)
      // Actions
      .bottom-0.sticky.z-1.white
        .d-flex.align-center.px-4.py-3.border-t
          .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledClear" @click="clear") {{ $t('clear') }}
          v-spacer
          v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledApply") {{ $t('apply') }}
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {DateTime} from "luxon";

export default {
  props: ['filter'],
  data() {
    return {
      showMenu: false,
      searchText: '',
      currentActivity: null,
      selectedActivity: null,
      currentValue: {
        label: `30 ${this.$t('day').toLowerCase()}s`,
        value: 30
      },
      selectedValue: {
        label: `30 ${this.$t('day').toLowerCase()}s`,
        value: 30
      },
      availableValues: [
        {
          label: `30 ${this.$t('day').toLowerCase()}s`,
          value: 30
        },
        {
          label: `60 ${this.$t('day').toLowerCase()}s`,
          value: 60
        },
        {
          label: `90 ${this.$t('day').toLowerCase()}s`,
          value: 90
        },
        {
          label: `180 ${this.$t('day').toLowerCase()}s`,
          value: 180
        },
        {
          label: `365 ${this.$t('day').toLowerCase()}s`,
          value: 365
        }
      ],
      availableActivities: [
        {
          label: this.$t('not_visited_for'),
          value: 'not_visited_since'
        },
        {
          label: this.$t('visited_last'),
          value: 'last_visit__gte'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledApply() {
      if (this.selectedActivity === null) return true

      if (this.currentActivity) return this.selectedActivity === this.currentActivity

      return false
    },
    disabledClear() {
      return this.selectedActivity === null
    },
    selectedActivityDisplay() {
      return this.currentActivity ? `${this.currentActivity.label} ${this.currentValue.label}` : null
    }
  },
  watch: {
    filter: {
      handler() {
        if (!this.filter.key) {
          this.clearData()
        }
      }
    },
    showMenu(value) {
      if (value && this.currentActivity && this.currentValue) {
        this.selectedActivity = {...this.currentActivity}
        this.selectedValue = {...this.currentValue}
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData() {
      this.selectedActivity = null
      this.currentActivity = null
      this.selectedValue = this.availableValues[0]
      this.currentValue = this.availableValues[0]
    },
    apply() {
      this.showMenu = false
      this.currentActivity = {...this.selectedActivity}
      this.currentValue = {...this.selectedValue}
      const key = this.selectedActivity.value
      const value = this.getFilterValue(this.selectedValue.value)
      this.$emit('update:filter', {key, value})
    },
    getFilterValue(lastNDays) {
      const now = DateTime.local()
      return now.minus({days: lastNDays}).toFormat('yyyy-MM-dd')
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}

.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>